// types/BuilderField.ts

export interface CustomFieldType {
  typeID: number;
  code: string;
  name: string;
  description?: string | null;
  dataKind: string; // string | integer | decimal | boolean | datetime | json
  color: string;
  icon: string;
  isActive: boolean;
  createdDateTime?: number | null;
  modifiedDateTime?: number | null;
}

// By intersecting string with an empty object, TypeScript preserves the literal 
// suggestions but allows any string the backend might send.
export type FieldTypeCode =
  | 'text'
  | 'textarea'
  | 'number'
  | 'decimal'
  | 'boolean'
  | 'date'
  | 'datetime'
  | 'email'
  | 'phone'
  | 'url'
  | 'select'
  | 'multiselect'
  | 'member'
  | (string & {});

export interface FieldTypeDef {
  code: FieldTypeCode;
  name: string;
  dataKind: 'string' | 'number' | 'boolean' | 'date' | 'array' | string;
}

export const FIELD_TYPES: FieldTypeDef[] = [
  { code: 'text', name: 'Text', dataKind: 'string' },
  { code: 'textarea', name: 'Text Area', dataKind: 'string' },
  { code: 'number', name: 'Number', dataKind: 'number' },
  { code: 'decimal', name: 'Decimal', dataKind: 'number' },
  { code: 'boolean', name: 'Yes / No', dataKind: 'boolean' },
  { code: 'date', name: 'Date', dataKind: 'date' },
  { code: 'datetime', name: 'Date Time', dataKind: 'date' },
  { code: 'email', name: 'Email', dataKind: 'string' },
  { code: 'phone', name: 'Phone', dataKind: 'string' },
  { code: 'url', name: 'URL', dataKind: 'string' },
  { code: 'select', name: 'Select', dataKind: 'string' },
  { code: 'multiselect', name: 'Multi Select', dataKind: 'array' },
  // Options come from the form's runtime context (e.g. the registration's members),
  // not the field definition; the stored value is the memberID.
  { code: 'member', name: 'Member', dataKind: 'number' },
];

export const OPTION_TYPES: FieldTypeCode[] = ['select', 'multiselect'];

export interface FieldOption {
  label: string;
  value: string;
}

export interface BuilderField {
  id: number | string;
  fieldKey: string;
  label: string;
  fieldType: FieldTypeCode;
  category: string;
  orderNo: number;
  required: boolean;
  active: boolean;
  placeholder?: string;
  defaultValue?: any;
  options?: FieldOption[];
}

export interface FieldRowGroup {
  orderNo: number;
  fields: BuilderField[];
}

export interface SectionGroup {
  category: string;
  rows: FieldRowGroup[];
}

export interface ValidationError {
  message: string;
}